import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { TaxInvoiceEntity } from './tax-invoice.entity'

export class TaxInvoicesRepository extends BaseRepository<TaxInvoiceEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/tax-invoices', token, cache)
    }

    async sendNFSe(taxInvoiceId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl + '/tax-invoices/' + taxInvoiceId + '/send?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async cancelNFSe(taxInvoiceId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl + '/tax-invoices/' + taxInvoiceId + '/cancel?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async syncNFSe(taxInvoiceId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl + '/tax-invoices/' + taxInvoiceId + '/sync?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getXML(taxInvoiceId: string) {
        const { json, text, statusCode, message } = await this.request.get(
            this.config.posApiUrl + '/tax-invoices/' + taxInvoiceId + '/xml?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json || text
        throw message
    }

    async getPDF(taxInvoiceId: string) {
        const { json, text, buffer, statusCode, message } = await this.request.get(
            this.config.posApiUrl + '/tax-invoices/' + taxInvoiceId + '/pdf?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json || text || buffer
        throw message
    }

    async getRPS(taxInvoiceId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl + '/tax-invoices/' + taxInvoiceId + '/rps?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
